<template>
    <div class="auth" @click="handleClose" v-if="visible">
      <div class="auth-box">
          <div class="title">Link with Your Google Account<i @click="handleClose"></i></div>
          <div class="btn" @click.stop="handleGoogleLogin">Continue with Google</div>
          <p>Linking your account with a Google Account helps prevent data loss and ensures your account’s security.</p>
          <div class="notice"><span @click="openUrl('terms')">Terms</span> | <span @click="openUrl('privacy')">Privacy</span></div>
      </div>
    </div>
  </template>
<script>
import { mapActions } from 'vuex';
import { auth } from '@/api';
import { googleLogin } from '@/utils';

export default {
  name: 'Loading',
  created() {
  },
  beforeDestroy() {
  },
  data() {
    return {
      visible: false,
      urlList: {
        privacy: 'https://toonfrenzy.com/privacy.html',
        terms: 'https://toonfrenzy.com/terms.html',
      },
    };
  },
  methods: {
    ...mapActions(['setUserInfo']),
    show() {
      this.visible = true;
    },
    handleClose() {
      this.visible = false;
      this.$destroy(true);
      this.$el.parentNode && this.$el.parentNode.removeChild(this.$el);
    },
    openUrl(key) {
      if (!key) return;
      window.location.href = this.urlList?.[key] ?? '';
    },
    async handleGoogleLogin() {
      const loading = this.$loading();
      googleLogin().then(async (res) => {
        const result = await auth(res);
        if (result.code !== 0) throw new Error('cannot auth');
        this.$toast.success('success');
        this.setUserInfo();
      }).catch((error) => {
        console.log(error);
        this.$toast.error('error, please try later');
      }).finally(() => {
        loading.close();
        this.handleClose();
      });
    //   console.log('res', res, loading);
    //   if (res) {
    //     const result = await auth(res);
    //     if (result.code !== 0) {
    //       this.$toast.error('error, please try later...');
    //     } else {
    //       this.$toast.success('success');
    //       this.setUserInfo();
    //     }
    //   }
    //   loading.close();
    //   this.handleClose();
    },
  },
};
</script>
  <style lang="less" scoped>
  .auth {
    height: 100vh;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    background: rgba(0, 0, 0, 0.6);
    z-index: 99;
    .auth-box {
      padding: 24px;
      background: #fff;
      margin-top: auto;
      border-top-right-radius: 12px;
      border-top-left-radius: 12px;
    }
    .title {
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 34px;
      display: flex;
      align-items: center;
      i {
        content: '';
        width: 24px;
        height: 24px;
        background: url('@/assets/images/icon/close.png') center no-repeat;
        background-size: 100%;
        margin-left: auto;
      }
    }
    .g_id_signin {
      display: flex;
    }
    p {
      margin-top: 24px;
    }
    .btn {
      height: 44px;
      line-height: 44px;
      text-align: center;
      font-size: @fontMedium;
      font-weight: 700;
      background: rgba(13, 13, 13, 0.06);
      border-radius: 99px;
      display: flex;
      align-items: center;
      justify-content: center;
      &::before {
        content: '';
        width: 24px;
        height: 24px;
        background: url(@/assets/images/icon/google.png) no-repeat center;
        background-size: 100%;
        margin-right: 8px;
      }
    }
    .notice {
      margin-top: 16px;
      color: @green;
      text-align: center;
      span {
        text-decoration: underline;
      }
    }
  }
  </style>
